import classNames from "classnames";
import { PortalAuthorRightViewModel } from "../../../generated/data-contracts";

interface IDelegatedRightsItemProps {
  isAssigned?: boolean;
  item: PortalAuthorRightViewModel;
}
export function DelegatedRightsItem(
  props: Readonly<IDelegatedRightsItemProps>,
) {
  const { item, isAssigned } = props;

  const classRightsItemCombined = classNames(
    "tab-roles-content-rights-item",
    "grid",
    isAssigned === true ? "assigned" : "not-assigned",
  );

  const itemName = isAssigned ? item.name : `* ${item.name}`;

  return (
    <div className={classRightsItemCombined}>
      <div className="col-6">{itemName}</div>
      <div className="col-6">{item.description}</div>
    </div>
  );
}
